import { Suspense, lazy, type ComponentProps } from 'react';
import { PageState } from '../../../components/ui';

/** React Flow (the canvas library) is only downloaded when a flow editor is actually opened. */
const FlowDefinitionEditor = lazy(() => import('./FlowDefinitionEditor'));

export function LazyFlowDefinitionEditor(props: ComponentProps<typeof FlowDefinitionEditor>) {
  return (
    <Suspense fallback={<PageState kind="loading" message="Loading the flow builder…" />}>
      <FlowDefinitionEditor {...props} />
    </Suspense>
  );
}
